export enum BulkRetargetingCampaignEndpoints {
  GET_ALL = '/sites/:siteId/bulk_retargeting_campaigns',
  GET = '/sites/:siteId/bulk_retargeting_campaigns/:campaignId',
  POST = '/sites/:siteId/bulk_retargeting_campaigns',
  PUT = '/sites/:siteId/bulk_retargeting_campaigns/:campaignId',
  PATCH = '/sites/:siteId/bulk_retargeting_campaigns/:campaignId',
}
